import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CartComponent from '../../components/CartComponent';
import SettingsComponent from '../../components/SettingsComponent';
import Menu from '../../components/Menu';
import MobileBottomNav from '../../components/MobileBottomNav';
import { useAuth } from '../../context/AuthContext';
import { useProfile } from '../../context/ProfileContext';

const Header = () => {
    const { isAuthenticated } = useAuth();
    const { userInfo } = useProfile();
    const [isSliderOpen, setSliderOpen] = useState(false);
    const location = useLocation();

    const toggleSlider = () => setSliderOpen(!isSliderOpen);
    const closeSlider = () => setSliderOpen(false);

    // Close slider when route changes
    useEffect(() => {
        closeSlider();
    }, [location.pathname]);

    // Close slider on escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isSliderOpen) {
                closeSlider();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isSliderOpen]);

    // Prevent body scroll when slider is open
    useEffect(() => {
        if (isSliderOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isSliderOpen]);

    // Hide wallet and notification on specific routes
    const shouldHideWalletAndNotification = ['/products', '/login', '/register'].includes(location.pathname);

    return (
        <>
            <header className="as_header_wrapper">
                <div className="header-row">
                    {/* Mobile Menu Toggle */}
                    <button
                        className="as_toggle"
                        onClick={toggleSlider}
                        aria-label="Toggle navigation menu"
                        aria-expanded={isSliderOpen}
                    >
                        <img alt="Menu" src="/assets/images/svg/menu.svg" />
                    </button>

                    {/* Logo */}
                    <Link to="/" className="logo-container">
                        <img
                            className="headerLogo"
                            src={`${process.env.PUBLIC_URL}/assets/images/astroscop.png`}
                            alt="Astroscope Logo"
                        />
                    </Link>

                    {/* Desktop Navigation */}
                    <nav className="as_menu d-none d-lg-flex" role="navigation">
                        <Menu isAuthenticated={isAuthenticated} />
                    </nav>

                    {/* Right side actions */}
                    <div className="header-actions d-flex align-items-center">
                        {/* Cart */}
                        <CartComponent />

                        {/* Wallet & Notifications */}
                        {!shouldHideWalletAndNotification && (
                            <>
                                <Link to="/recharge-plans" className="as_cart" title="Wallet">
                                    <div className="as_cart_wrapper">
                                        <img alt="Wallet" className='headerSvg' src="/assets/images/svg/wallet.svg" />
                                        <span className="walletAmount">
                                            {userInfo?.wallet_balance ? `₹${userInfo.wallet_balance}` : ''}
                                        </span>
                                    </div>
                                </Link>

                                <button className="as_cart" title="Notifications">
                                    <div className="as_cart_wrapper">
                                        <span>
                                            <img alt="Notifications" className='headerSvg' src="/assets/images/svg/notification.svg" />
                                            {/* {cartCount > 0 && <span className="as_cartnumber">{cartCount}</span>} */}
                                            {<span className="as_cartnumber">0</span>}
                                        </span>
                                    </div>
                                </button>
                            </>
                        )}

                        {/* Authentication */}
                        {!isAuthenticated ? (
                            <Link to="/login" className="profileLogin">
                                Login
                            </Link>
                        ) : (
                            <SettingsComponent />
                        )}
                    </div>
                </div>
            </header>

            {/* Mobile Slider Menu */}
            <div className={`menu_slider ${isSliderOpen ? 'menu_open' : ''}`}>
                <button
                    className="close_btn"
                    onClick={closeSlider}
                    aria-label="Close menu"
                >
                    &times;
                </button>

                <nav role="navigation" className="as_menu">
                    <Menu
                        isAuthenticated={isAuthenticated}
                        hideMenue={isSliderOpen}
                        onClose={closeSlider}
                    />
                </nav>
            </div>

            {/* Backdrop */}
            {isSliderOpen && (
                <div
                    className="backdrop show"
                    onClick={closeSlider}
                    aria-hidden="true"
                />
            )}

            {/* Header Spacer */}
            <div className="as_header_spacer"></div>

            {/* Mobile Bottom Navigation */}
            <MobileBottomNav />
        </>
    );
};

export default Header;
